import { generateConfigurationTemplate } from "pages/ConfigurationPage/configurationTemplate.ts"
import { useEffect, useMemo, useState } from "react"
import { useTranslation } from "react-i18next"
import {
  Box,
  Checkbox,
  Flex,
  GridLayout,
  SingleSelect,
  SingleSelectOption,
  Typography,
} from "@strapi/design-system"

import { useBrandsQuery } from "hooks/query/useBrandsQuery.ts"

interface ConfigurationFeaturesProps {
  data: any
  onChange: (data: any) => void
  onValid: (valid: boolean) => void
}

export const ConfigurationFeatures = ({ data, onChange }: ConfigurationFeaturesProps) => {
  const { t } = useTranslation()
  const [isMobile, setIsMobile] = useState(false)
  const { data: brands } = useBrandsQuery()
  const configurationTemplate = useMemo(() => {
    return generateConfigurationTemplate(t, brands || [])
  }, [t, brands])

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 900)
    }
    handleResize()
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  return (
    <Box padding={6} background="neutral0" hasRadius>
      <Flex direction={isMobile ? "column" : "row"} gap={6} wrap="wrap" alignItems="flex-start">
        <Box flex={1} style={{ minWidth: isMobile ? "100%" : "600px" }}>
          {configurationTemplate.map(({ key, title, type, list }) => {
            const sectionKey = key

            if (type === "checkbox")
              return (
                <Box key={key} marginBottom={4}>
                  <Typography variant="beta">{title}</Typography>
                  <Box padding={2} />
                  <GridLayout>
                    {list.map(({ key, title }) => (
                      <Checkbox
                        key={`${key}-${title}`}
                        checked={data.config[sectionKey].includes(key)}
                        onChange={() =>
                          onChange({
                            ...data,
                            config: {
                              ...data.config,
                              [sectionKey]: data.config[sectionKey].includes(key)
                                ? data.config[sectionKey].filter((item) => item !== key)
                                : [...data.config[sectionKey], key],
                            },
                          })
                        }
                      >
                        {title}
                      </Checkbox>
                    ))}
                  </GridLayout>
                </Box>
              )
          })}
        </Box>

        <Box flex={1}>
          {configurationTemplate.map(({ key, title, type, list }) => {
            const sectionKey = key
            if (type === "select")
              return (
                <Box key={key} marginBottom={4}>
                  <Typography>{title}</Typography>
                  <SingleSelect
                    value={data.config[sectionKey]}
                    onChange={(value) =>
                      onChange({
                        ...data,
                        config: {
                          ...data.config,
                          [sectionKey]: value,
                        },
                      })
                    }
                  >
                    {list.map(({ key, title }) => (
                      <SingleSelectOption key={`${key}-${title}`} value={key}>
                        {title}
                      </SingleSelectOption>
                    ))}
                  </SingleSelect>
                </Box>
              )
          })}
        </Box>
      </Flex>
    </Box>
  )
}
